import { render, staticRenderFns } from "./institutionDialog.vue?vue&type=template&id=45955f5a&scoped=true"
import script from "./institutionDialog.vue?vue&type=script&lang=js"
export * from "./institutionDialog.vue?vue&type=script&lang=js"
import style0 from "./institutionDialog.vue?vue&type=style&index=0&id=45955f5a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45955f5a",
  null
  
)

export default component.exports